import React, { useEffect } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import './App.css';

// Importar componentes de las páginas
import Home from './pages/Home.jsx';
import Timer from './pages/Timer.jsx';
import Calculator from './pages/Calculator.jsx';
import Bitacora from './pages/Bitacora.jsx';
import Alerts from './pages/Alerts.jsx';
import FAQ from './pages/FAQ.jsx';
import Retorno from './pages/Retorno.jsx';
import NotFound from './pages/NotFound';
import NavBar from './components/NavBar';

function App({ onAppReady }) {
  // Ocultar el splash screen cuando el componente se monte
  useEffect(() => {
    const hideSplash = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          await SplashScreen.hide({ fadeOutDuration: 0 });
          console.log('SplashScreen ocultado desde App');
        } catch (e) {
          console.warn('Error al ocultar el splash screen en App:', e);
        }
      }
    };

    // Llamar a onAppReady si está definido
    if (onAppReady) {
      onAppReady();
    } else {
      // Si no hay onAppReady, ocultar el splash screen directamente
      hideSplash();
    }
  }, [onAppReady]);
  return (
    <HashRouter>
      <div className="app-container">
        <NavBar />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/timer" element={<Timer />} />
            <Route path="/estimador" element={<Calculator />} />
            <Route path="/retorno" element={<Retorno />} />
            <Route path="/bitacora" element={<Bitacora />} />
            <Route path="/alertas" element={<Alerts />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </HashRouter>
  );
}

export default App;
